import React, { useEffect, useState } from "react";
import { CreditCard } from "lucide-react";
import { useTheme } from "../../../contexts/ThemeContext";
import { useAuth } from "../../../contexts/AuthContext";
import { getMetodosPago } from "../../../services/wordpress/micuenta";
import { Pill } from "../Pill";

export const MetodosPago = () => {
  const { mode } = useTheme() || { mode: "light" };
  const isDark = mode === "dark";
  const auth = useAuth();

  const [metodos, setMetodos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  const textPrimary = isDark ? "#f1f5f9" : "#1e293b";
  const textSecondary = isDark ? "#94a3b8" : "#64748b";
  const borderColor = isDark ? "rgba(255,255,255,0.08)" : "#e2e8f0";
  const iconBg = isDark ? "rgba(255,255,255,0.06)" : "#f1f5f9";

  useEffect(() => {
    if (!auth.apiToken || !auth.wpUrl) {
      setCargando(false);
      return;
    }
    let cancelado = false;
    getMetodosPago({ wpUrl: auth.wpUrl, apiToken: auth.apiToken })
      .then((data) => {
        if (!cancelado) setMetodos(data);
      })
      .catch(() => {
        if (!cancelado) setError("No se pudieron cargar los métodos de pago.");
      })
      .finally(() => {
        if (!cancelado) setCargando(false);
      });
    return () => {
      cancelado = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.apiToken, auth.wpUrl]);

  return (
    <div>
      <p style={{ fontSize: 14, color: textSecondary, margin: "0 0 16px 0" }}>
            Gestiona tus métodos de pago para futuras compras.
          </p>

          {cargando ? (
            <p style={{ fontSize: 13, color: textSecondary, margin: 0 }}>Cargando...</p>
          ) : metodos.length === 0 ? (
            <p
              style={{
                fontSize: 13,
                color: textSecondary,
                fontStyle: "italic",
                margin: 0,
              }}
            >
              {error || "Aún no has configurado ningún método de pago."}
            </p>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {metodos.map((m) => (
                <div
                  key={m.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 12,
                    padding: "12px 16px",
                    borderRadius: 14,
                    border: `1px solid ${borderColor}`,
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 34,
                        height: 34,
                        borderRadius: 10,
                        backgroundColor: iconBg,
                        flexShrink: 0,
                      }}
                    >
                      <CreditCard size={16} color={textSecondary} />
                    </span>
                    <span style={{ fontSize: 13, color: textPrimary }}>{m.descripcion}</span>
                  </div>
                  {m.predeterminado && <Pill tone="active">Predeterminado</Pill>}
                </div>
              ))}
            </div>
          )}
    </div>
  );
};
